module.exports = __webpack_public_path__ + "img/fig06.47b444ae.jpg";